import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useAppDispatch, useAppSelector } from '../../lib/redux/hook'
import { CompanyIcon } from '../../ui/icons/companyIcon'
import { LayoutComponent } from '../../ui/layout'
import { BillowButton } from '../../ui/molecules/billowButton'
import { Pagination } from '../../ui/organisms/pagination'
import { MenuItems } from '../../ui/organisms/sidebar/dto'
import { CustomerFilters } from './filters'
import { CustomerList } from './list'
import { NewCustomerModal } from './newCustomerModal'
import { findAllCustomers, setCustomerFilterPage, setOpenNewCustomerModal } from './slice'
import { PlusIcon } from '../../ui/icons/plusIcon'

export default function Customer() {

  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const customerState = useAppSelector(state => state.customer)
  const authState = useAppSelector(state => state.auth)

  useEffect(() => {
    dispatch(findAllCustomers({ ...customerState.customerFilters, page: customerState.customerFilters.page }))
  }, [customerState.customerFilters.page])

  return (
    <LayoutComponent menuItem={MenuItems.LISTING} headingLabel={'Clienti'}
      headingButtons={
        (authState.findMeUserResponse?.email.trim()) ? [
        <BillowButton icon={<PlusIcon size={'20'} color={'white'} />} onClick={() => dispatch(setOpenNewCustomerModal(true))} 
        iconPosition={'left'} variant={'solid'} label='Crea cliente' />
        ] : []
      }
      breadcrumbItems={['Clienti']} breadcrumbIcon={<CompanyIcon size={'20'} color={'#6237FB'} />}>
      <CustomerFilters />
      <CustomerList />
      {
        customerState.findAllCustomersResponse !== undefined &&
        customerState.findAllCustomersResponse.customers.length > 0 &&
        <div className="flex bg-white drop-shadow-sm items-center justify-center p-2">
          <Pagination
            pages={customerState.findAllCustomersResponse.totalPage || 1}
            currentPage={customerState.findAllCustomersResponse.page}
            setPage={(page) => dispatch(setCustomerFilterPage(page))}
          />
        </div>
      }
      <NewCustomerModal />
    </LayoutComponent>
  )
}
